import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep, reverse } from 'lodash';
import localforage from 'localforage';

import moStore, { toggleValue } from '@store/index';
import moUser from '@store/user';
import moLogin, { toggleLogin } from '@store/login';
import Service from '@service/index';
import moMenu, { menuInit } from './menu';
import moSingle, {
  singleInit,
} from '@/page/effect/component/single-industry/store/index';
import moMulti from '@/page/effect/component/multi-industry/store/index';
import moCompany from '@/page/effect/component/company-sample/store/index';
import moCost, { costInit } from '../salary-cost/store/index';
import WorkService from '@/service/work';
import moHumanIndustry, { changeDefaltIndustry, changeIndustryShow, changeIndustryTab, changeTimeTab, getHumanEfficiencyIndustry } from '../human-resources/store/industry';
import EffectService from '@service/effect';
import { changeMomentShow, changeMomentTab, getHumanEfficiencyTime } from '../human-resources/store/time';
import moChangeRate, { changeDefaltRate, changeRateTab, getRatioDistribution } from '../human-resources/store/change-rate';
import moCapital, { changeCapShow, changeCapTab, changeDataTime, changeDefaltCapital, getCapitalAnalysis } from '../human-resources/store/capital-analysis';
import moOutput, { changeDefaltOuttime, changeOutTab, getOutputTop10 } from '../human-resources/store/output';
import { getRevenueRankings, huringShow } from '../human-resources/store/huring';
import { changeStaffTab, changeStaShow, getStaffSize } from '../human-resources/store/staff-size';
import moSupport, { supportInit } from '../support-effect/store/index';
import moIndustryEffect, {
  industryEffectInit, supportTimeChange, changeStaff, changeType as changeSupportIndustryType,
} from '../support-effect/industry-effect/store';
import moEffectTrend, {
  effectTrendInit, changeTrendStaff, changeType as changeSupportTrendType,
} from '../support-effect/effect-trend/store/index';
import moSettleCompare, {
  timeTabChange as settleIndustryTimeChange,
  changeType as settleIndustryTypeChange,
  settleCompareInit,
} from '../stuff-settle/industry-compare/store';
import moTimeTrend, {
  changeType as settleTimeTrendTypeChange,
  timeTrendInit,
} from '../stuff-settle/time-trend/store/index';
import moDistribution, {
  timeTabChange as settleRatioTimeChange,
  distributionInit,
} from '../stuff-settle/distribution-rate/store';
import moStaffTrend, {
  changeType as settleStaffTrendTypeChange,
  staffTrendInit,
} from '../stuff-settle/stuff-trend/store';
import moCompare, {
  changeTab as costCompareTabChange,
  timeTabChange as costCompareYearChange,
  changeType as costCompareTypeChange,
  compareInit,
} from '../salary-cost/industry-compare/store';
import moTrend, {
  changeTab as costTrendTabChange,
  changeType as costTrendTypeChange,
  trendInit,
} from '../salary-cost/time-trend/store/index';
import moFee, {
  changeType as costFeeTypeChange,
  feeInit,
} from '../salary-cost/fee-rate/store/index';
import { changeModule } from './sider';
import URI from 'urijs';

const moEffect = observable({
  isLook: false,
  yearList: <any[]>[],
  funYearList: <any[]>[],
  showIndicator: true,
  timeData: <any>{},
  updateTime: '',
  effectpdfmodel: false,
  year: <any>'2021',
});

const effectInit = action(async (isMenu = true) => {
  const { isLogin } = moUser;
  // console.log('init...');
  if (!isLogin) {
    toggleValue('isLoading', false);
    toggleLogin(true);
    return;
  }

  // 初次进入页面时，指标说明 展开
  // 否则 关闭
  if (localStorage.getItem('showIndicator') === 'false') {
    moEffect.showIndicator = false;
  } else {
    moEffect.showIndicator = true;
  }
  localStorage.setItem('showIndicator', 'false');

  toggleValue('isLoading', true);
  if (isMenu) await menuInit();

  changeStaff(moMenu.staffIndustryNumber);
  changeTrendStaff(moMenu.staffTrendNumber);

  const list = await WorkService.yearOption();
  const humanData: any = await localforage.getItem('humans') || {};
  runInAction(() => {
    moEffect.yearList = list;
    const data = cloneDeep(list);
    moEffect.funYearList = reverse(data);
    if (!isEmpty(list)) {
      const active = list.length - 1;
      moEffect.year = list[active];
      changeDefaltIndustry(list[active]);
      changeDefaltRate(list[active]);
      changeDefaltCapital(list[active]);
      changeDefaltOuttime(list[active]);
      changeDataTime(list[active]);
      if (humanData.industrytime) {
        changeDefaltIndustry(humanData.industrytime);
      }
      if (humanData.industrytable) {
        changeIndustryShow(humanData.industrytable);
      }
      if (humanData.industrytab) {
        changeIndustryTab(humanData.industrytab);
      }

      if (humanData.momenttab) {
        changeMomentTab(humanData.momenttab);
      }
      if (humanData.momenttable) {
        changeMomentShow(humanData.momenttable);
      }

      if (humanData.ratetab) {
        changeRateTab(humanData.ratetab);
      }
      if (humanData.ratetime) {
        changeDefaltRate(humanData.ratetime);
      }

      if (humanData.captime) {
        changeDefaltCapital(humanData.captime);
      }
      if (humanData.captable) {
        changeCapShow(humanData.captable);
      }
      if (humanData.captab) {
        changeCapTab(humanData.captab);
      }

      if (humanData.stafftab) {
        changeStaffTab(humanData.stafftab);
      }
      if (humanData.stafftable) {
        changeStaShow(humanData.stafftable);
      }

      if (humanData.outputtab) {
        changeOutTab(humanData.outputtab);
      }
      if (humanData.outputtime) {
        changeDefaltOuttime(humanData.outputtime);
      }

      if (humanData.huringtable) {
        huringShow(humanData.huringtable);
      }

      // 支持效能 - 各行业支持效能 年份初始化
      const supportIndustryYear = localStorage.getItem('supportIndustryEffectYear') || list[active];
      supportTimeChange(supportIndustryYear, true);
      // 人员配置 - 行业对比 年份初始化
      const settleIndustryYear = localStorage.getItem('settleIndustryYear') || list[active];
      settleIndustryTimeChange(settleIndustryYear, true);
      // 人员配置 - 变化率分布 年份初始化
      const settleRatioYear = localStorage.getItem('settleRatioYear') || list[active];
      settleRatioTimeChange(settleRatioYear, true);
      // 薪酬成本投入 - 行业对比
      const costCompareYear = localStorage.getItem('costCompareYear') || list[active];
      costCompareYearChange(costCompareYear, true);
    }
  });

  const supportIndustryEffectType = localStorage.getItem('effectIndustrySupport') || 'chart';
  changeSupportIndustryType(supportIndustryEffectType);
  const supportTimeTrendType = localStorage.getItem('effectTimeTrend') || 'chart';
  changeSupportTrendType(supportTimeTrendType);
  const settleIndustryType = localStorage.getItem('settleIndustryType') || 'chart';
  settleIndustryTypeChange(settleIndustryType);
  const settleTimeTrendType = localStorage.getItem('settleTimeTrendType') || 'chart';
  settleTimeTrendTypeChange(settleTimeTrendType);
  const settleStaffTrendType = localStorage.getItem('settleStaffTrendType') || 'chart';
  settleStaffTrendTypeChange(settleStaffTrendType);
  const costCompareTab = localStorage.getItem('costCompareTab') || '总薪酬成本占比';
  costCompareTabChange(costCompareTab);
  const costCompareType = localStorage.getItem('costCompareType') || 'chart';
  costCompareTypeChange(costCompareType);
  const costTrendType = localStorage.getItem('costTrendType') || 'chart';
  costTrendTypeChange(costTrendType);
  const costTrendTab = localStorage.getItem('costTrendTab') || '总薪酬成本占比';
  costTrendTabChange(costTrendTab);
  const costFeeType = localStorage.getItem('costFeeType') || 'chart';
  costFeeTypeChange(costFeeType);

  try {
    const dataList = await Promise.all([
      WorkService.humanEfficiencyIndustry({
        year: moHumanIndustry.industryTimeActive,
      }),
      WorkService.humanEfficiencyTime(),
      WorkService.ratioDistribution({
        year: moChangeRate.rateTimeActive,
      }),
      WorkService.capitalAnalysis({
        year: moCapital.capitalTimeActive,
      }),
      WorkService.outputTop10({
        year: moOutput.outputTimeActive,
      }),
      WorkService.revenueRankings(),
      WorkService.staffSize(),
      EffectService.supportMultiIndustry({
        year: moIndustryEffect.timeActive,
        staff_num: moMenu.staffIndustryNumber,
      }),
      EffectService.supportYearTrend({
        staff_num: moMenu.staffTrendNumber,
      }),
      EffectService.settleMultiIndustry({
        year: moSettleCompare.timeActive,
      }),
      EffectService.settleTimeTrend(),
      EffectService.settleRatio({
        year: moDistribution.timeActive,
      }),
      EffectService.settleStaffTimeTrend(),
      EffectService.costMultiIndustryRequest({
        year: moCompare.timeActive,
      }),
      EffectService.costTimeTrendRequest(),
      EffectService.costFeeRateRequest(),
    ]);
    if (!isEmpty(dataList)) {
      getHumanEfficiencyIndustry(dataList[0]);
      getHumanEfficiencyTime(dataList[1]);
      getRatioDistribution(dataList[2]);
      getCapitalAnalysis(dataList[3]);
      getOutputTop10(dataList[4]);
      getRevenueRankings(dataList[5]);
      getStaffSize(dataList[6]);
      industryEffectInit(dataList[7]);
      effectTrendInit(dataList[8]);
      settleCompareInit(dataList[9]);
      timeTrendInit(dataList[10]);
      distributionInit(dataList[11]);
      staffTrendInit(dataList[12]);
      compareInit(dataList[13]);
      trendInit(dataList[14]);
      feeInit(dataList[15]);
    }
    const uri = new URI(window.location.href);
    const res: any = uri.query(true);
    const euem: any = {
      a: '人效时间趋势',
      b: '人效行业对比',
      c: '人员配置行业对比',
      d: '支持效能行业对比',
      e: 'Top10公司列表',
    };
    if (res.key) {
      setTimeout(() => {
        changeModule(euem[res.key]);
      }, 1000);
    }
  } catch {
    toggleValue('isLoading', false);
  }

  const data = await WorkService.dataProfile();
  runInAction(() => {
    moEffect.timeData = data;
  });
  const result: any = await Service.updateTime();
  runInAction(() => {
    moEffect.updateTime = result.efficiency;
  });
  setTimeout(() => {
    toggleValue('isLoading', false);
  }, 1000);
});

const toggleLook = action((value: boolean) => {
  moEffect.isLook = value;
});

// 修改弹框

const changePdfModel = action((val: boolean) => {
  runInAction(() => {
    moEffect.effectpdfmodel = val;
  });
});

export default moEffect;
export { effectInit, toggleLook, changePdfModel };
